module.exports = __webpack_public_path__ + "media/images/zohocrm-61dd62df087a5e764dc06ccb3e7bafea.svg";